export default {"src":"/_next/static/media/servers.18a4f244.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};